import React, { type FC, memo } from 'react';

import CustomTooltip from '../../Antd/TextTooltip/CustomTooltip';
import { StyledTitle } from '../../BlueTheme/Title/styled';
import WarningNotification from '../../WarningNotification';
import { StyledBlueButton, StyledButtonWrapper, StyledDescription, StyledTitleWrapper, Wrapper } from './styled';

type Props = {
  title: string;
  buttonTitle?: string;
  description?: string;
  hideActionButton?: boolean;
  onActionClick?(): void;
  actionButtonDisabled?: boolean;
  isLimitReached?: boolean;
  additionalButton?: JSX.Element;
  withTopPadding?: boolean;
  disableReason?: string;
};

const PageHeader: FC<Props> = ({
  title,
  buttonTitle,
  description,
  hideActionButton = false,
  actionButtonDisabled = false,
  onActionClick,
  isLimitReached = false,
  additionalButton,
  withTopPadding,
  disableReason = '',
}): JSX.Element => (
  <Wrapper data-testid="pageHeader" withTopPadding={withTopPadding}>
    <StyledTitleWrapper>
      <StyledTitle>{title}</StyledTitle>
      <div>
        <>{additionalButton}</>
        {!hideActionButton && (
          <CustomTooltip title={disableReason}>
            <StyledButtonWrapper>
              <StyledBlueButton
                type="button"
                data-testid={`${title}${buttonTitle}`}
                onClick={onActionClick}
                disabled={actionButtonDisabled || isLimitReached}
              >
                {buttonTitle}
              </StyledBlueButton>
            </StyledButtonWrapper>
          </CustomTooltip>
        )}
      </div>
    </StyledTitleWrapper>
    {description && <StyledDescription data-testid="pageHeaderDescription">{description}</StyledDescription>}
    {isLimitReached && (
      <WarningNotification
        title="You have reached your maximum Ad upload limit."
        description="To continue Ad upload, please delete any unused Ads."
        testId="warningAdLimitReachedNotification"
      />
    )}
  </Wrapper>
);

export default memo(PageHeader);
